import { render, staticRenderFns } from "./SeminarEventData.vue?vue&type=template&id=f5c043b2&scoped=true"
import script from "./SeminarEventData.vue?vue&type=script&lang=js"
export * from "./SeminarEventData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c043b2",
  null
  
)

export default component.exports